export default __webpack_public_path__ + "static/media/suitcase@3x.7ec9b966.png";